import React, { useContext } from "react";
import { FrequentListProvider } from "./contexts/FrequentListContext";
import { MarkedRecipeProvider } from "./contexts/MarkedRecipesContext";
import { MenuPlanProvider } from "./contexts/MenuPlanContext";
import { RecipeProvider } from "./contexts/RecipeContext";
import { ShoppingListProvider } from "./contexts/ShoppingListContext";
import { UserContext, UserProvider } from "./contexts/UserContext";

const AuthenticatedProviders = ({ children }) => {
  const { user } = useContext(UserContext);

  if (!user) {
    return children; // Render only public content if user is not logged in
  }

  return (
    <MenuPlanProvider>
      <MarkedRecipeProvider>
        <FrequentListProvider>
          <ShoppingListProvider>{children}</ShoppingListProvider>
        </FrequentListProvider>
      </MarkedRecipeProvider>
    </MenuPlanProvider>
  );
};

const AppProviders = ({ children }) => {
  return (
    <UserProvider>
      <RecipeProvider>
        <AuthenticatedProviders>{children}</AuthenticatedProviders>
      </RecipeProvider>
    </UserProvider>
  );
};

export default AppProviders;
